import { ScheduleDisplay } from "@/modules/care-provider/components/schedule-display"
import { useCareProviderWithOriginQuery$data } from "@/modules/care-provider/services/__generated__/useCareProviderWithOriginQuery.graphql"

type CareProvider = useCareProviderWithOriginQuery$data["ch_careProviderByRelationalId"]

type CareProviderOpeningHoursTabProps = {
  careProvider: CareProvider
}

const CareProviderOpeningHoursTab = ({ careProvider }: CareProviderOpeningHoursTabProps) => {
  return (
    <div className="h-195">
      {careProvider?.detailedSchedule && careProvider.detailedSchedule.length > 0 && (
        <ScheduleDisplay detailedSchedule={careProvider.detailedSchedule} showAllDays />
      )}
    </div>
  )
}

export { CareProviderOpeningHoursTab }
